export default __webpack_public_path__ + "static/media/library-image-02.717e9c43.png";